(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["batch-20-solomahj-facts"] && !Shopify.designMode) return;
  try {
    
  const formatSoloMahjPrice = (cents, currency) => {
    const amount = cents / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const hydrateSoloMahjFacts = async (root) => {
    if (root.dataset.b20Ready === 'true') return;
    root.dataset.b20Ready = 'true';
    const currency = root.dataset.currency || 'USD';
    const cards = [...root.querySelectorAll('.smj-pc')];

    await Promise.all(cards.map(async (card) => {
      const linkedAction = card.querySelector('a[href*="/products/"]');
      const storedAction = card.querySelector('[data-product-handle]');
      const handle = storedAction?.dataset.productHandle || linkedAction?.getAttribute('href')?.split('/products/')[1]?.split(/[?#]/)[0];
      if (!handle) return;
      const price = card.querySelector('.smj-price');

      try {
        const response = await fetch(`${window.Shopify.routes.root}products/${handle}.js?batch20_facts=1`, { credentials:'same-origin' });
        if (!response.ok) throw new Error('Product unavailable');
        const product = await response.json();
        if (price) price.textContent = `${product.price_varies ? 'From ' : ''}${formatSoloMahjPrice(product.price, currency)}`;

        if (!product.available) {
          const action = linkedAction || storedAction;
          if (action) {
            action.outerHTML = `<span class="smj-btn smj-btn-navy b20-product-action b20-product-action--disabled" data-product-handle="${handle}" aria-disabled="true" style="border-color:#8a91a8 !important;color:#565f78 !important;background:#eef0f5 !important;cursor:not-allowed !important;">Currently unavailable</span>`;
          }
          if (!card.querySelector('.b20-availability-badge')) {
            const heading = card.querySelector('h3');
            heading?.insertAdjacentHTML('beforebegin', '<span class="b20-availability-badge">Currently unavailable</span>');
          }
        } else if (storedAction && storedAction.tagName !== 'A') {
          storedAction.outerHTML = `<a href="/products/${handle}" class="smj-btn smj-btn-navy b20-product-action">Shop now</a>`;
          card.querySelector('.b20-availability-badge')?.remove();
        }
      } catch {
        if (price) price.textContent = 'See current price';
      }
    }));

    root.classList.remove('b20-solomahj--loading');
    root.classList.add('b20-solomahj--ready');
    const status = root.querySelector('.b20-solomahj__status');
    if (status) status.textContent = 'SoloMahj prices and availability are current.';
  };

  document.querySelectorAll('[data-b20-solomahj]').forEach(hydrateSoloMahjFacts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batch-21-accessibility"] && !Shopify.designMode) return;
  try {
    
  const initializeBatch21Accessibility = () => {
    if (document.documentElement.dataset.batch21Accessibility === 'ready') return;
    document.documentElement.dataset.batch21Accessibility = 'ready';

    const footerInput = document.getElementById('lmje-footer-email');
    const footerTrigger = document.getElementById('lmje-footer-join');
    const signupModal = document.getElementById('lmje-nlm');
    const signupModalBox = signupModal?.querySelector('.lmje-nlm__box');
    const signupClose = document.getElementById('lmje-nlm-close');
    const signupDescription = signupModal?.querySelector('.lmje-nlm__sub');
    const signupTitle = document.getElementById('lmje-nlm-title');

    if (footerTrigger && signupModal) {
      const footerRow = footerTrigger.closest('.lmje-mf__nl-row');
      footerInput?.remove();
      footerRow?.classList.add('b21-single-trigger');
      footerTrigger.classList.add('b21-signup-trigger');
      footerTrigger.textContent = 'Get the free cheat sheet';
      footerTrigger.setAttribute('aria-haspopup', 'dialog');
      footerTrigger.setAttribute('aria-controls', signupModal.id);
      footerTrigger.setAttribute('aria-expanded', 'false');
      signupClose?.setAttribute('aria-label', 'Close free cheat sheet signup');

      if (signupDescription) {
        signupDescription.textContent = 'One short note a week, plus the free quick-start cheat sheet. Enter your email below.';
        signupDescription.id = signupDescription.id || 'lmje-nlm-description';
        signupModal.setAttribute('aria-describedby', signupDescription.id);
      }

      if (signupTitle) {
        signupTitle.setAttribute('role', 'heading');
        signupTitle.setAttribute('aria-level', '2');
      }

      const syncSignupState = () => {
        const isOpen = signupModal.classList.contains('is-open');
        footerTrigger.setAttribute('aria-expanded', String(isOpen));
        document.body.classList.toggle('b21-modal-open', isOpen);
        const embeddedForm = signupModal.querySelector('iframe');
        if (embeddedForm && !embeddedForm.title) embeddedForm.title = 'Free cheat sheet email signup form';
      };

      new MutationObserver(syncSignupState).observe(signupModal, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden'],
        childList: true,
        subtree: true,
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !signupModal.classList.contains('is-open')) return;
        const focusable = [...signupModal.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])')]
          .filter((element) => element.getClientRects().length > 0);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        } else if (!signupModalBox?.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        }
      }, true);

      syncSignupState();
    }

    const guidesHeading = [...document.querySelectorAll('h2')].find((heading) =>
      heading.textContent.replace(/\s+/g, '').includes('Startwiththeguideseveryoneelsedoes.')
    );
    guidesHeading?.setAttribute('aria-label', 'Start with the guides everyone else does.');

    const quiz = document.getElementById('quizBlock');
    if (!quiz) return;
    const quizIntro = document.getElementById('quizIntro');
    const quizQuestions = document.getElementById('quizQuestions');
    const quizResult = document.getElementById('quizResult');
    const quizStart = quiz.querySelector('.quiz-start-btn, .btn-start');
    const quizNext = document.getElementById('nextBtn');
    const progress = document.getElementById('progressBar') || document.getElementById('progressFill');
    const questionPanels = [...quiz.querySelectorAll('.quiz-q')];

    quizQuestions?.setAttribute('role', 'region');
    quizQuestions?.setAttribute('aria-label', 'Mahjong Edit quiz');
    quizResult?.setAttribute('role', 'status');
    quizResult?.setAttribute('aria-live', 'polite');
    quizStart?.setAttribute('aria-controls', 'quizQuestions');
    progress?.setAttribute('role', 'progressbar');
    progress?.setAttribute('aria-label', 'Quiz progress');
    progress?.setAttribute('aria-valuemin', '0');
    progress?.setAttribute('aria-valuemax', '100');

    questionPanels.forEach((panel, panelIndex) => {
      const questionText = panel.querySelector('.quiz-q-text');
      const group = panel.querySelector('.quiz-options');
      const options = [...panel.querySelectorAll('.quiz-option')];
      if (questionText) questionText.id = questionText.id || `b21-quiz-question-${panelIndex + 1}`;
      group?.setAttribute('role', 'radiogroup');
      if (questionText) group?.setAttribute('aria-labelledby', questionText.id);

      options.forEach((option, optionIndex) => {
        option.setAttribute('role', 'radio');
        option.setAttribute('aria-checked', String(option.classList.contains('selected')));
        option.tabIndex = optionIndex === 0 ? 0 : -1;
        option.addEventListener('click', () => requestAnimationFrame(syncQuizState));
        option.addEventListener('keydown', (event) => {
          const keys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'];
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            option.click();
            return;
          }
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let nextIndex = optionIndex;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (optionIndex + 1) % options.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (optionIndex - 1 + options.length) % options.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = options.length - 1;
          options[nextIndex].focus();
          options[nextIndex].click();
        });
      });
    });

    const syncQuizState = () => {
      const questionsActive = quizQuestions?.classList.contains('active') || false;
      const resultActive = quizResult?.classList.contains('active') || false;
      quizIntro?.setAttribute('aria-hidden', String(questionsActive || resultActive));
      quizQuestions?.setAttribute('aria-hidden', String(!questionsActive));
      quizResult?.setAttribute('aria-hidden', String(!resultActive));
      quizStart?.setAttribute('aria-expanded', String(questionsActive));

      let visibleQuestionIndex = 0;
      questionPanels.forEach((panel, panelIndex) => {
        const isVisible = questionsActive && getComputedStyle(panel).display !== 'none';
        panel.setAttribute('aria-hidden', String(!isVisible));
        if (isVisible) visibleQuestionIndex = panelIndex;
        const options = [...panel.querySelectorAll('.quiz-option')];
        const selectedIndex = options.findIndex((option) => option.classList.contains('selected'));
        options.forEach((option, optionIndex) => {
          option.setAttribute('aria-checked', String(option.classList.contains('selected')));
          option.tabIndex = optionIndex === (selectedIndex >= 0 ? selectedIndex : 0) ? 0 : -1;
        });
      });

      const progressValue = resultActive ? 100 : questionsActive ? Math.round((visibleQuestionIndex / questionPanels.length) * 100) : 0;
      progress?.setAttribute('aria-valuenow', String(progressValue));
    };

    quiz.addEventListener('click', (event) => {
      const startButton = event.target.closest('.quiz-start-btn, .btn-start');
      const nextButton = event.target.closest('#nextBtn');
      const restartButton = event.target.closest('.quiz-restart-btn, .btn-restart');
      if (!startButton && !nextButton && !restartButton) return;
      requestAnimationFrame(() => {
        syncQuizState();
        if (quizResult?.classList.contains('active')) {
          const resultHeading = quizResult.querySelector('.result-heading');
          if (resultHeading) {
            resultHeading.tabIndex = -1;
            resultHeading.focus();
          }
          return;
        }
        const visiblePanel = questionPanels.find((panel) => getComputedStyle(panel).display !== 'none');
        visiblePanel?.querySelector('.quiz-option[tabindex="0"]')?.focus();
      });
    });

    new MutationObserver(syncQuizState).observe(quiz, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true,
    });

    syncQuizState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBatch21Accessibility, { once: true });
  } else {
    initializeBatch21Accessibility();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
